import * as React from 'react';
import { Block, Text } from '../../../../../../../components';

const RegisterDataUser = (props: any) => {
  const { period, career, weightedAverage, hasDebts } = props;
  return (
    <>
      <Block
        data-testid="cmp-RegisterDataUser-01"
        customized
        margin="0px 0px 20px"
      >
        <Text lineHeight="20px" fontSize="14px">
          Los datos que aparecerán en tu constancia son:{' '}
        </Text>
      </Block>
      <Block>
        <ul style={{ listStyle: 'unset', marginLeft: 16 }}>
          {period && (
            <li>
              <Text lineHeight="20px" fontSize="14px">
                Periodo: <strong>{period}.</strong>
              </Text>
            </li>
          )}
          {career && (
            <li>
              <Text lineHeight="20px" fontSize="14px">
                Carrera: <strong>{career}.</strong>
              </Text>
            </li>
          )}
          {weightedAverage && (
            <li>
              <Text lineHeight="20px" fontSize="14px">
                Promedio ponderado acumulado:{' '}
                <strong>{weightedAverage.toString().replace('.', ',')}.</strong>
              </Text>
            </li>
          )}
          {hasDebts !== null && (
            <li>
              <Text lineHeight="20px" fontSize="14px">
                Detalle:{' '}
                <strong>
                  {hasDebts ? 'Mantiene deudas' : 'No mantiene deudas'}.
                </strong>
              </Text>
            </li>
          )}
        </ul>
      </Block>
      {/* <Block>
        {<ActionableButton
          text="Continuar"
          marginTop={24}
          enabled
          onClick={onClick}
        />}
      </Block> */}
    </>
  );
};

export default RegisterDataUser;
